export default __webpack_public_path__ + "static/media/cards.36cb89be.png";